module.exports = __webpack_public_path__ + "static/img/notimg.59a63405.png";